import React from 'react'
import { MDBIcon } from 'mdb-react-ui-kit'
import EventCard from '../EventCard/EventCard.component'

import './EventsGrid.component.scss'

/**
 * EventsGrid Component
 *
 * Displays a responsive grid of EventCards with a section header.
 *
 * @param {Object} props
 * @param {string} props.title - Section title
 * @param {Array} props.events - Array of event objects
 * @param {Function} props.onEventClick - Click handler for event cards
 * @param {boolean} props.isPast - Whether these are past events
 * @param {boolean} props.isLoading - Loading state
 * @param {string} props.emptyMessage - Message to show when no events
 */
const EventsGrid = ({
  title,
  events = [],
  onEventClick,
  isPast = false,
  isLoading = false,
  emptyMessage = 'No events to display.',
}) => {
  if (isLoading) {
    return (
      <div className='EventsGridComponent'>
        {title && (
          <div className='grid-header'>
            <h3 className='grid-title'>{title}</h3>
          </div>
        )}
        <div className='grid-loading'>
          <MDBIcon icon='spinner' spin size='2x' />
          <span>Loading events...</span>
        </div>
      </div>
    )
  }

  return (
    <div className={`EventsGridComponent ${isPast ? 'past-events' : ''}`}>
      {title && (
        <div className='grid-header'>
          <h3 className='grid-title'>
            {isPast && <MDBIcon icon='history' className='title-icon' />}
            {!isPast && <MDBIcon icon='calendar-check' className='title-icon' />}
            {title}
          </h3>
          {events.length > 0 && (
            <span className='event-count'>
              {events.length} {events.length === 1 ? 'event' : 'events'}
            </span>
          )}
        </div>
      )}

      {events.length === 0 ? (
        <div className='grid-empty'>
          <MDBIcon icon={isPast ? 'archive' : 'calendar-times'} size='3x' />
          <p>{emptyMessage}</p>
        </div>
      ) : (
        <div className='events-grid'>
          {events.map((event, idx) => (
            <EventCard key={`event-${event.id}-${idx}`} event={event} onClick={onEventClick} isPast={isPast} />
          ))}
        </div>
      )}
    </div>
  )
}

export default EventsGrid
